import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import Err from "../../../../../../routes/error";
import ChecklistComponent from "@Shared/components/checklist/checklist";
import { mapActions } from "vuex";
import { DELETE_CHECKLIST, EDIT_CHECKLIST } from "@Broker/@Modules/clients/board/store/board-actions";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { showToast } from "@Shared/utils/constants";
import TimelineItemCard from "./utils/timeline-card.vue";
import TimelineCardFooter from "./utils/timeline-card-footer.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineChecklist",
  components: {
    ChecklistComponent,
    InlinePrompt,
    ProfileAvatar,
    TimelineItemCard,
    TimelineCardFooter
  },
  props: {
    creator: {
      type: Object,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    activityType: {
      type: String,
      required: true
    },
    pinned: {
      type: Boolean,
      required: true
    },
    checklist: {
      type: Array,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    latestUpdate: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      editingTitle: false,
      localData: {}
    };
  },
  computed: {
    name() {
      const {
        givenName,
        familyName
      } = this.creator;
      return this.$options.filters.nameFormat(givenName, familyName);
    },
    parsedChecklist() {
      return {
        checklist: this.checklist,
        id: this.id
      };
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [DELETE_CHECKLIST, EDIT_CHECKLIST])), {}, {
    handlePin(id, type, pinned) {
      this.$emit("pin", id, type, pinned);
    },
    async handleDelete() {
      try {
        await this.DELETE_CHECKLIST({
          id: this.clientProfileId,
          checklistId: this.id
        });
        showToast("success", "checklistDeleted");
        Amplitude.logEvent("Board - checklist deleted", {
          page: "clients-board",
          checklistId: this.id,
          clientProfileId: this.clientProfileId
        });
      } catch (error) {
        Err.handle(error);
      }
    },
    async handleUpdate({
      checklist,
      title
    }) {
      try {
        if (!this.editingTitle) await this.EDIT_CHECKLIST({
          id: this.clientProfileId,
          checklistId: this.id,
          data: checklist,
          title
        });else this.localData = {
          checklist,
          title
        };
      } catch (error) {
        Err.handle(error);
      }
    },
    handleEditChecklist() {
      this.editingTitle = !this.editingTitle;
      if (!(this.editingTitle || isEmpty(this.localData))) {
        this.handleUpdate(this.localData);
      }
    }
  })
});